import { useRouteLoaderData } from '@remix-run/react';

import Template1 from './Templates/Template1';

const Footer = () => {
  // biome-ignore lint/suspicious/noExplicitAny: Leaving this for backwards compatibility
  const { publication, subscription, signupWidgetConfigs } = useRouteLoaderData<any>('root');

  return <Template1 publication={publication} subscription={subscription} signupWidgetConfigs={signupWidgetConfigs} />;
};

export default Footer;
